<template>
  <div id="overview-wrap">
    <h2>{{ characterName ? characterName : 'Overview' }} {{ characterClass && characterName ? `the ${characterClass}`: '' }}</h2>
    <h4>Level {{ characterLevel }} {{ characterRace && characterRace != 'Other' ? characterRace : '' }}</h4>
    <div class="look-overview">
      {{ characterLook.body }} body,
      {{ characterLook.eyes.toLowerCase() }} eyes,
      {{ characterLook.hair.toLowerCase() }} hair,
      and wearing {{ characterLook.clothes.toLowerCase() }} clothes.
    </div>
    <Stats :forOverview="true" />
    <Moves :forOverview="true" :filterMoves="filterMoves" />
    <Gear :forOverview="true" />
    <SaveButtons :noClear="true" />
  </div>
</template>
 
<script>
import Stats from "../Stats/Stats.vue";
import Gear from "../Gear/Gear.vue";
import Moves from "../Moves/Moves.vue";
import SaveButtons from "../../util/SaveButtons.vue";

import util from "../../util/util.js";

// Have all the info on one screen, just not very pretty
export default {
  name: "Overview",
  components: {
    Stats,
    Gear,
    Moves,
    SaveButtons
  },
  methods: {
    filterMoves: function(moves) {
      let result = {};
      Object.keys(moves).forEach(key => {
        if (key === "starting") {
          result[key] = moves[key];
        } else if (key === "advanced") {
          let temp = moves[key].filter(move => move.have);
          if (temp.length > 0) {
            result[key] = temp;
          }
        } else if (key === "expert") {
          let temp = moves[key].filter(move => move.have);
          if (temp.length > 0) {
            result[key] = temp;
          }
        }
      });
      return result;
    }
  },
  computed: {
    characterName() {
      return this.$store.state.character.name;
    },
    characterClass() {
      return util.capitalize(this.$store.state.character.class);
    },
    characterRace() {
      return this.$store.state.character.race.title;
    },
    characterLevel() {
      return this.$store.state.character.level;
    },
    characterLook() {
      return this.$store.state.character.look;
    }
  }
};
</script>

<style lang="css">
#overview-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
}

#overview-wrap h2 {
  margin-bottom: 0;
}

#overview-wrap > h4 {
  margin-top: 0.3em;
  margin-bottom: 0.5em;
}

.look-overview {
  width: 90%;
  font-size: 16px;
  margin-bottom: 1em;
}
</style>